import { httpUtil } from './httpUtil'
import { ErrorCodes, createResult, createCommonResult } from './resultUtil'

export const account = {
    createPrimaryAccount,
    getPrimaryAccount,
    getWalletInfo,
    getWaleltBalances,
    getRewards,
    updateAccountRewards,
    getAccountMerchants,
    getMerchants,
    addMerchantToAccount,
    topUpWallet,
    createPaymentFormTopup,
    getWaleltJournal,
    getWeeklyTransactions,
    getAccountJournals,
    getJournal,
    getWallet,
}

async function getWalletInfo(accountId) {
    try {
        if (!accountId) {
            let primeAccRes = await getPrimaryAccount();
            if (primeAccRes.code != ErrorCodes.OK)
                return primeAccRes;
            if (!primeAccRes.data.content && primeAccRes.data.content.size() == 0)
                return createResult(ErrorCodes.ACCOUNT_NOT_FOUND, response.error);
            accountId = primeAccRes.data.content[0].id;
        }
        let response = await httpUtil.get({
            resourcePath: '/v1/accounts/' + accountId + '/financials',
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception register: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getRewards(accountId, include_rewards) {
    try {
        if (!accountId) {
            let primeAccRes = await getPrimaryAccount();
            if (primeAccRes.code != ErrorCodes.OK)
                return primeAccRes;
            if (!primeAccRes.data.content && primeAccRes.data.content.size() == 0)
                return createResult(ErrorCodes.ACCOUNT_NOT_FOUND, response.error);
            accountId = primeAccRes.data.content[0].id;
        }
        let response = await httpUtil.get({
            resourcePath: '/v1/accounts/' + accountId + '/rewards',
            queryParams: { include_rewards },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception register: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getWaleltBalances({
    walletId,
    page = 1,
    size = 10,
    sort,//='UPDATED_DATE',
    order, //='DESC'
} = {}) {
    try {
        if (!walletId) {
            let walletInfoRes = await getWalletInfo();
            if (walletInfoRes.code != ErrorCodes.OK)
                return walletInfoRes;
            walletId = walletInfoRes.data.wallet.id;
        }

        let response = await httpUtil.get({
            resourcePath: '/v1/wallets/' + walletId + '/balances',
            queryParams: {
                page,
                size,
                sort,
                order
            },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception register: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getPrimaryAccount() {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: '/v1/contacts/' + id + '/accounts',
            queryParams: { is_primary: true },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception register: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}


async function createPrimaryAccount() {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.post({
            resourcePath: '/v1/contacts/' + id + '/accounts',
            body: { is_primary: true }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception register: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateAccountRewards({
    minimum_wallet_balance,
    from_purchase_amount,
    enable_automatic_spend,
}) {
    try {
        if (!minimum_wallet_balance)
            minimum_wallet_balance = null;

        if (!from_purchase_amount)
            from_purchase_amount = null;

        let primeAccRes = await getPrimaryAccount();
        if (primeAccRes.code != ErrorCodes.OK)
            return primeAccRes;
        if (!primeAccRes.data.content && primeAccRes.data.content.size() == 0)
            return createResult(ErrorCodes.ACCOUNT_NOT_FOUND, response.error);
        var accountId = primeAccRes.data.content[0].id;

        let automaticSpendPreference = (minimum_wallet_balance && from_purchase_amount) ? "ALL_MERCHANT_PURCHASE" : "NEXT_MERCHANT_PURCHASE";
        var automatic_spend_settings = {
            enable_automatic_spend: enable_automatic_spend,
            automatic_spend_preference: enable_automatic_spend ? automaticSpendPreference : null,
            minimum_wallet_balance: minimum_wallet_balance ? Number(minimum_wallet_balance) : null,
            from_purchase_amount: from_purchase_amount ? Number(from_purchase_amount) : null
        }
        let response = await httpUtil.put({
            resourcePath: '/v1/accounts/' + accountId + '/rewards',
            body: {
                automatic_spend_settings: automatic_spend_settings
            },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception register: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getAccountMerchants(accountId) {
    try {
        if (!accountId) {
            let primeAccRes = await getPrimaryAccount();
            if (primeAccRes.code != ErrorCodes.OK)
                return primeAccRes;
            if (!primeAccRes.data.content && primeAccRes.data.content.size() == 0)
                return createResult(ErrorCodes.ACCOUNT_NOT_FOUND, response.error);
            accountId = primeAccRes.data.content[0].id;
        }
        let response = await httpUtil.get({
            resourcePath: '/v1/accounts/' + accountId + '/merchants',
            queryParams: {},
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception register: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getMerchants({
    page = 1,
    size = 100,
    sort,//='UPDATED_DATE',
    order, //='DESC'
} = {}) {
    try {

        let response = await httpUtil.get({
            resourcePath: '/v1/merchants',
            queryParams: {
                page,
                size,
                sort,
                order
            },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception merchants: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function addMerchantToAccount(merchants) {
    try {
        let primeAccRes = await getPrimaryAccount();
        if (primeAccRes.code != ErrorCodes.OK)
            return primeAccRes;
        if (!primeAccRes.data.content && primeAccRes.data.content.size() == 0)
            return createResult(ErrorCodes.ACCOUNT_NOT_FOUND, response.error);
        var accountId = primeAccRes.data.content[0].id;
        let response = await httpUtil.post({
            resourcePath: '/v1/accounts/' + accountId + '/merchants',
            body: { merchants: merchants }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception register: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function topUpWallet({
    wallet_id,
    topup_date,
    amount,
    payment_method = 'CARD',
    payment_method_id,
    code }) {
    try {
        let response = await httpUtil.post({
            resourcePath: '/v1/topups',
            body: {
                wallet_id,
                topup_date,
                amount,
                payment_method,
                payment_method_id,
                code
            }
        });
        if (response.error && response.error.error == "CRM.EXCEPTIONS.PAYMENTGATEWAYEXCEPTION") {
            return createResult(ErrorCodes.PAYMENT_GATEWAY_EXCEPTION, response.error);
        } else 
            return createCommonResult(response);
    } catch (e) {
        console.log('Exception register: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function createPaymentFormTopup({
	topup_amount,
	payment_method_id,
    redirect_url
}) {
	try {
		let response = await httpUtil.get({
			resourcePath: '/v1/jcc/payment_form',
			withAccessToken: true,
			queryParams: {
				topup_amount,
				payment_method_id,
                redirect_url
			},
			returnText: true
		});
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception createPaymentFormTopup: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}


async function getWaleltJournal({
    walletId,
    page = 1,
    size = 10,
    sort,//='UPDATED_DATE',
    order, //='DESC'
} = {}) {
    try {
        if (!walletId) {
            let walletInfoRes = await getWalletInfo();
            if (walletInfoRes.code != ErrorCodes.OK)
                return walletInfoRes;
            walletId = walletInfoRes.data.wallet.id;
        }

        let response = await httpUtil.get({
            resourcePath: '/v1/wallets/' + walletId + '/transactions',
            queryParams: {
                page,
                size,
                sort,
                order
            },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getWaleltJournal: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getWeeklyTransactions({
    walletId,
    page = 1,
    size = 10,
    order, //='DESC'
    from_date,
    to_date, //epoch time
} = {}) {
    try {
        if (!walletId) {
            let walletInfoRes = await getWalletInfo();
            if (walletInfoRes.code != ErrorCodes.OK)
                return walletInfoRes;
            walletId = walletInfoRes.data.wallet.id;
        }
        let query = {
            page,
            size,
            order
        };
        if(from_date){
            query["posted_on[gte]"] = from_date;
        }
        if(to_date){
            query["posted_on[lte]"] = to_date;
        }
        let response = await httpUtil.get({
            resourcePath: '/v1/wallets/' + walletId + '/transactions',
            queryParams: query,
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getContactPurchases: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getAccountJournals({
    accountId,
    page = 1,
    size = 10,
    order, //='DESC'
    from_date,
    to_date, //epoch time
    transaction_type
}) {
    try {
        if (!accountId) {
            let primeAccRes = await getPrimaryAccount();
            if (primeAccRes.code != ErrorCodes.OK)
                return primeAccRes;
            if (!primeAccRes.data.content && primeAccRes.data.content.size() == 0)
                return createResult(ErrorCodes.ACCOUNT_NOT_FOUND, response.error);
            accountId = primeAccRes.data.content[0].id;
        }
        let query = {
            page,
            size,
            order,
            transaction_type,
        };
        if(from_date){
            query["posted_on[gte]"] = from_date;
        }
        if(to_date){
            query["posted_on[lte]"] = to_date;
        }
        let response = await httpUtil.get({
            resourcePath: '/v1/accounts/' + accountId + '/journals',
            queryParams: query,
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getAccountJournals: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getJournal(invoiceId) {
    try {
        let response = await httpUtil.get({
            resourcePath: '/v1/journals/' + invoiceId,
            queryParams:{
                include_lines: true
            },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getJournal: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getWallet(walletId) {
    try {
        if (!walletId) {
            let walletInfoRes = await getWalletInfo();
            if (walletInfoRes.code != ErrorCodes.OK)
                return walletInfoRes;
            walletId = walletInfoRes.data.wallet.id;
            console.log("gaga:",walletId);
        }

        let response = await httpUtil.get({
            resourcePath: '/v2/wallets/' + walletId,
            withAccessToken: true,
            logOutIfSessionInvalid: false,            
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getWallet: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
